__turbopack_context__.v({
  "ambientGlow": "SubpageShell-module__rjFmCa__ambientGlow",
  "ambientGrid": "SubpageShell-module__rjFmCa__ambientGrid",
  "eyebrow": "SubpageShell-module__rjFmCa__eyebrow",
  "footerArea": "SubpageShell-module__rjFmCa__footerArea",
  "heroContent": "SubpageShell-module__rjFmCa__heroContent",
  "heroImage": "SubpageShell-module__rjFmCa__heroImage",
  "heroSection": "SubpageShell-module__rjFmCa__heroSection",
  "heroSectionWithImage": "SubpageShell-module__rjFmCa__heroSectionWithImage",
  "primaryHeading": "SubpageShell-module__rjFmCa__primaryHeading",
  "subHeading": "SubpageShell-module__rjFmCa__subHeading",
});
